/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { Overflow, assertSlots } from '@fluentui/react-components';
import type { ReferenceListState, ReferenceListSlots, ReferenceListContextValues } from './ReferenceList.types';
import { ReferenceListContextProvider } from '../../contexts/referenceListContext';
import type { JSXElement } from '@fluentui/react-utilities';

/**
 * Render the final JSX of ReferenceList
 */
export const renderReferenceList_unstable = (
  state: ReferenceListState,
  contextValues: ReferenceListContextValues,
): JSXElement => {
  assertSlots<ReferenceListSlots>(state);

  const { minVisibleReferences } = state;

  return (
    <ReferenceListContextProvider value={contextValues.referenceList}>
      <Overflow minimumVisible={minVisibleReferences}>
        <state.root>
          <state.arrowableRegion />
          {state.showMoreButton && <state.showMoreButton />}
          {state.showLessButton && <state.showLessButton />}
        </state.root>
      </Overflow>
    </ReferenceListContextProvider>
  );
};
